var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgProcessIcon = function SvgProcessIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 0C4.925 0 0 4.835 0 10.8c0 3.636 1.87 6.984 4.889 8.964V24h2.444v-3.6h2.445V24h2.444v-3.6h2.445V24h2.444v-4.248C20.13 17.772 22 14.4 22 10.8 22 4.835 17.075 0 11 0M6.111 10.8c1.35 0 2.445 1.075 2.445 2.4S7.46 15.6 6.11 15.6s-2.444-1.075-2.444-2.4 1.094-2.4 2.444-2.4zm9.778 0c1.35 0 2.444 1.075 2.444 2.4s-1.094 2.4-2.444 2.4-2.445-1.075-2.445-2.4 1.095-2.4 2.445-2.4M11 14.4l1.833 3.6H9.167z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProcessIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;